<template>
  <page-section>
    <integration-couponsets-table :integration-id="model.id" />
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import IntegrationCouponsetsTable from '@/modules/integrations/components/IntegrationCouponsetsTable'

export default {
  name: 'WarplyCouponsets',
  components: {
    IntegrationCouponsetsTable,
    PageSection
  },
  props: {
    model: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/warply/WarplyCouponsets.vue